/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Project Team from
 * https://undraw.co
 */

function Icon({ size, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 787.067 428.128" {...props}>
      <path
        d="M178.18 372.278a400.444 400.444 0 01-3.776 51.454c-.082.6-.173 1.198-.256 1.797l-161.217-.901a66.264 66.264 0 01-1.39-1.806 76.647 76.647 0 01-4.211-6.233c-6.224-10.331-9.074-22.427-6.218-30.773l.05-.13a14.644 14.644 0 012.859-4.966c6.51-7.329 19.674-6.107 31.62-.192-10.715-11.728-19.246-26.527-19.894-39.738-.636-12.885 6.102-22.09 13.41-29.912.239-.258.479-.51.718-.761.117-.13.24-.252.356-.38 5.702-5.962 12.349-11.839 21.97-11.128 10.552.781 22.25 9.62 30.454 19.919 8.203 10.292 13.654 21.983 19.179 33.394 5.532 11.403 11.517 23.098 20.395 32.845-12.024-15.209-21.719-32.513-25.3-49.343s-.43-32.993 10.287-40.92a25.064 25.064 0 0110.979-4.43c.462-.076.932-.138 1.409-.194 9.92-1.128 21.764 2.303 31.842 10.504 11.098 9.03 18.792 22.417 22.62 35.125 3.829 12.708 4.237 24.942 4.113 36.769z"
        fill="#f2f2f2"
      />
      <path
        d="M72.702 424.962l-3.083-.017q-1.468-.918-2.95-1.815c-.612-.386-1.23-.758-1.85-1.136q-15.338-9.368-30.869-17.972-15.516-8.61-31.188-16.428a1.292 1.292 0 01-.742-1.477.372.372 0 01.05-.108c.147-.273.472-.387.948-.153 1.281.642 2.57 1.285 3.852 1.942q15.715 7.95 31.295 16.695 15.569 8.741 30.96 18.254c.216.131.433.27.648.4.979.605 1.95 1.21 2.929 1.815zM112.45 425.184l-1.906-.01c-.43-.602-.852-1.204-1.282-1.806q-15.153-21.248-30.299-42.496-24.804-34.787-49.592-69.574a1.228 1.228 0 01-.215-.42c-.141-.513.236-.814.72-.761a1.448 1.448 0 011.007.64q13.906 19.51 27.805 39.003l49.342 69.218c1.046 1.465 2.092 2.936 3.138 4.4.43.603.86 1.204 1.282 1.806zM154.919 414.114c-.097 3.212-.31 6.374-.588 9.506l-.161 1.797-2-.011c.06-.599.122-1.198.176-1.797.422-4.525.722-9.101.763-13.802a192.54 192.54 0 00-3.79-38.81 241.645 241.645 0 00-11.74-40.32 276.902 276.902 0 00-19.208-39.894 1.065 1.065 0 01-.176-.708c.082-.57.841-.74 1.409-.195a1.655 1.655 0 01.286.363q1.384 2.38 2.718 4.774a276.709 276.709 0 0118.384 40.032 240.501 240.501 0 0110.944 40.382 189.953 189.953 0 012.983 38.683z"
        fill="#fff"
      />
      <path
        d="M713.398 331.61c0-7.732-29.101-14-65-14s-65 6.268-65 14c0 4.956 11.965 9.307 30 11.795v76.705a6.5 6.5 0 0013 0v-75.324c6.872.533 14.277.824 22 .824s15.128-.291 22-.824v75.324a6.5 6.5 0 0013 0v-76.705c18.036-2.488 30-6.84 30-11.795z"
        fill="#ccc"
      />
      <circle cx={655.586} cy={175.468} r={28} fill="#2f2e41" />
      <path
        fill="#a0616a"
        d="M585.905 415.034h-12.26l-5.832-47.288h18.094l-.002 47.288z"
      />
      <path
        d="M564.888 411.53h23.644v14.887h-38.53a14.887 14.887 0 0114.886-14.886z"
        fill="#2f2e41"
      />
      <path
        fill="#a0616a"
        d="M566.768 408.192l-11.698-3.671 8.592-46.865 17.264 5.417-14.158 45.119z"
      />
      <path
        d="M547.764 398.557l22.559 7.08-4.457 14.203-36.763-11.537a14.887 14.887 0 0118.66-9.746zM570.756 389.324a4.462 4.462 0 01-1.572-.286l-9.02-3.382a4.516 4.516 0 01-2.813-5.183c2.27-10.21 10.01-44.971 14.247-63.616 5.026-22.115 78.343-26.224 81.461-26.388l.257-.014 8.247 10.364c2.98 9.58 2.036 17.051-2.807 22.208-14.133 15.047-56.328 5.71-61.36 4.529l-22.427 58.87a4.513 4.513 0 01-4.213 2.898z"
        fill="#2f2e41"
      />
      <path
        d="M583.756 396.324a4.462 4.462 0 01-1.572-.286l-9.02-3.382a4.516 4.516 0 01-2.813-5.183c2.27-10.21 10.01-44.971 14.247-63.616 5.026-22.115 78.343-26.224 81.461-26.388l.257-.014 8.247 10.364c2.98 9.58 2.036 17.051-2.807 22.208-14.133 15.046-56.328 5.71-61.36 4.529l-22.427 58.87a4.513 4.513 0 01-4.213 2.898z"
        fill="#2f2e41"
      />
      <path
        d="M557.661 252.304a10.527 10.527 0 01.885 1.402l49.32 5.196 7.1-9.734 16.09 8.795-13.944 23.62-60.487-15.422a10.496 10.496 0 111.036-13.857z"
        fill="#a0616a"
      />
      <path
        d="M672.274 311.786a4.5 4.5 0 01-2.05-.5c-9.862-5.015-29.066-13.7-46.874-15.517a4.392 4.392 0 01-3.095-1.75 4.519 4.519 0 01-.834-3.511c1.607-8.896 5.293-31.547 4.818-49.701a24.596 24.596 0 0118.582-24.468 79.866 79.866 0 019.913-1.954 24.795 24.795 0 0127.56 28.762c-3.176 18.813-6.378 45.09-3.595 63.432a4.507 4.507 0 01-1.819 4.349 4.429 4.429 0 01-2.606.858z"
        fill="#6c63ff"
      />
      <path
        d="M625.152 263.935a4.496 4.496 0 01-1.786-.373L610.518 258a4.506 4.506 0 01-2.342-5.917l9.931-22.942a11.5 11.5 0 1121.108 9.135l-9.932 22.943a4.51 4.51 0 01-4.13 2.716z"
        fill="#6c63ff"
      />
      <circle cx={654.562} cy={182.019} r={24.561} fill="#a0616a" />
      <path
        d="M629.559 169.952a88.59 88.59 0 0038.326 12.628l-4.04-4.84a29.688 29.688 0 009.17 1.82c3.131-.048 6.41-1.253 8.187-3.83a9.342 9.342 0 00.626-8.63 17.694 17.694 0 00-5.567-6.96 33.14 33.14 0 00-30.844-5.513 19.806 19.806 0 00-9.213 5.91c-2.328 2.872-6.81 5.43-5.618 8.93z"
        fill="#2f2e41"
      />
      <path
        d="M658.692 150.131a75.485 75.485 0 00-27.463-17.76c-6.639-2.459-13.865-3.978-20.805-2.581s-13.504 6.198-15.44 13.007c-1.584 5.569.05 11.564 2.508 16.806s5.738 10.102 7.725 15.54a35.468 35.468 0 01-35.69 47.562c6.82.914 13.106 4.12 19.771 5.825s14.533 1.59 19.487-3.185c5.24-5.053 5.345-13.267 5.092-20.543l-1.13-32.445c-.192-5.515-.356-11.207 1.633-16.355s6.716-9.656 12.235-9.61c4.182.036 7.884 2.57 11.238 5.069s6.905 5.165 11.07 5.536 8.924-2.711 8.612-6.882"
        fill="#2f2e41"
      />
      <path
        d="M613.269 305.477a11.004 11.004 0 114.242-21.164 10.567 10.567 0 011.312.665l44.74-20.087 1.257-12.134 19.286-.516-.128 20.201a10.88 10.88 0 01-7.86 10.343l-52.323 14.893a10.26 10.26 0 01-.359 1.02 11.045 11.045 0 01-10.167 6.779z"
        fill="#a0616a"
      />
      <path
        d="M682.473 262.144a4.496 4.496 0 01-1.762.476l-13.974.86a4.506 4.506 0 01-4.767-4.216l-1.534-24.953a11.5 11.5 0 1122.956-1.412l1.534 24.953a4.51 4.51 0 01-2.453 4.292z"
        fill="#6c63ff"
      />
      <path
        d="M652.103 308h-79a3.5 3.5 0 01-3.5-3.5 3.5 3.5 0 013.5-3.5h79a3.5 3.5 0 013.5 3.5 3.5 3.5 0 01-3.5 3.5z"
        fill="#3f3d56"
      />
      <path
        d="M538.603 301.5v-49a6.507 6.507 0 016.5-6.5h89a6.507 6.507 0 016.5 6.5v49a6.507 6.507 0 01-6.5 6.5h-89a6.507 6.507 0 01-6.5-6.5z"
        fill="#3f3d56"
      />
      <circle cx={589.603} cy={277} r={6} fill="#fff" />
      <path
        d="M276.78 219.337a10.056 10.056 0 00-15.32-1.744l-31.754-16.39 1.974 18.464 29.852 12.734a10.11 10.11 0 0015.249-13.064z"
        fill="#ffb8b8"
      />
      <path
        d="M248.56 226.77a4.505 4.505 0 01-3.668.039l-30.163-13.085a46.373 46.373 0 01-23.462-22.697l-15.857-33.471a14.497 14.497 0 1122.901-17.78l27.873 51.713 25.737 19.441a4.515 4.515 0 011.586 4.922l-2.526 8.159a4.506 4.506 0 01-1.524 2.211 4.455 4.455 0 01-.897.547z"
        fill="#ccc"
      />
      <circle cx={174.712} cy={93.631} r={24.561} fill="#ffb8b8" />
      <path
        fill="#ffb8b8"
        d="M184.661 415.827h12.259l5.833-47.288h-18.095l.003 47.288z"
      />
      <path
        d="M220.565 427.21l-38.531.001v-14.886l23.643-.002a14.887 14.887 0 0114.888 14.887z"
        fill="#2f2e41"
      />
      <path
        fill="#ffb8b8"
        d="M144.661 415.827h12.259l5.833-47.288h-18.095l.003 47.288z"
      />
      <path
        d="M180.565 427.21l-38.531.001v-14.886l23.643-.002a14.887 14.887 0 0114.888 14.887zM140.38 402.292a4.499 4.499 0 01-1.075-3.559l21.464-160.985 53.329 9.056 5.691-3.415-14.717 152.744a4.512 4.512 0 01-4.096 3.964l-16.148 1.346a4.5 4.5 0 01-4.866-4.742l4.18-72.742a.5.5 0 00-.982-.16l-20.683 76.7a4.508 4.508 0 01-4.344 3.329h-14.367a4.498 4.498 0 01-3.386-1.536z"
        fill="#2f2e41"
      />
      <path
        d="M177.312 249.016a3.533 3.533 0 00-4.516-.188l-10.662 8.293a4.496 4.496 0 01-7.087-2.307c-5.23-18.315-17.079-64.418-14.16-96.866 1.655-18.393 17.538-32.371 35.405-31.198 12.216.814 20.252 7.861 23.886 20.944 8.923 32.122 18.729 91.044 20.604 102.53a4.48 4.48 0 01-2.137 4.59 32.939 32.939 0 01-16.692 4.696c-7.119 0-15.655-2.478-24.64-10.494z"
        fill="#ccc"
      />
      <path
        d="M181.335 260.443a10.056 10.056 0 00-10.979-10.827l-14.872-32.493-9.841 15.747 15.631 28.442a10.11 10.11 0 0020.061-.87z"
        fill="#ffb8b8"
      />
      <path
        d="M154.543 248.876a4.505 4.505 0 01-2.911-2.234l-15.66-28.909a46.373 46.373 0 01-4.454-32.339l8.179-36.123a14.497 14.497 0 1128.992.142l-9.981 57.892 8.254 31.181a4.515 4.515 0 01-1.789 4.852l-7.023 4.86a4.506 4.506 0 01-2.564.8 4.455 4.455 0 01-1.043-.122z"
        fill="#ccc"
      />
      <path opacity={0.2} d="M166.697 173.828l-9 38 13 32-9-31 5-39z" />
      <path
        d="M160.697 113.828a16.538 16.538 0 01-6.388-1.156c-.894-.345-1.823-.628-2.715-.973-7.882-3.045-13.074-11.439-13.26-19.886s4.19-16.646 10.685-22.05 14.91-8.177 23.335-8.819c9.075-.69 19.294 1.61 24.365 9.168 1.35 2.012 2.294 4.453 1.494 6.882a4.403 4.403 0 01-1.24 1.906c-2.265 2.015-4.523.5-6.832.366-3.173-.184-6.023 2.385-7.047 5.393s-.574 6.322.253 9.391a23.46 23.46 0 011.183 5.71 5.74 5.74 0 01-2.379 5.055c-1.983 1.199-4.587.505-6.57-.692s-3.7-2.86-5.842-3.74-5.023-.686-6.27 1.266a6.935 6.935 0 00-.793 2.29c-1.118 5.094-.861 4.794-1.98 9.889z"
        fill="#2f2e41"
      />
      <path
        d="M373.648 197.178a4.32 4.32 0 01-.807-3.705 102.328 102.328 0 000-47.525 4.321 4.321 0 01.807-3.705 4.248 4.248 0 013.355-1.626h39.873a4.302 4.302 0 014.237 3.606 167.487 167.487 0 010 50.975 4.302 4.302 0 01-4.237 3.606h-39.873a4.248 4.248 0 01-3.355-1.626zM311.967 56.56a4.318 4.318 0 01-.807-3.704 102.332 102.332 0 000-47.525 4.318 4.318 0 01.807-3.705A4.247 4.247 0 01315.322 0h39.873a4.303 4.303 0 014.237 3.606 167.487 167.487 0 010 50.975 4.303 4.303 0 01-4.237 3.606h-39.873a4.247 4.247 0 01-3.355-1.626z"
        fill="#e6e6e6"
      />
      <path
        d="M410.079 103.598a167.487 167.487 0 010-50.975 4.302 4.302 0 014.237-3.606h39.872a4.247 4.247 0 013.355 1.627 4.32 4.32 0 01.808 3.704 102.328 102.328 0 000 47.525 4.318 4.318 0 01-.808 3.705 4.247 4.247 0 01-3.355 1.626h-39.872a4.302 4.302 0 01-4.237-3.606z"
        fill="#6c63ff"
      />
      <path
        d="M243.156 101.819a167.506 167.506 0 010-50.976 4.303 4.303 0 014.237-3.606h39.872a4.247 4.247 0 013.356 1.627 4.32 4.32 0 01.807 3.704 102.328 102.328 0 000 47.525 4.318 4.318 0 01-.807 3.705 4.247 4.247 0 01-3.356 1.626h-39.872a4.303 4.303 0 01-4.237-3.605z"
        fill="#ff6584"
      />
      <path
        d="M253.018 219.49a4.39 4.39 0 01-.821-3.766 104.001 104.001 0 000-48.306 4.392 4.392 0 01.82-3.766 4.318 4.318 0 013.411-1.652h40.527a4.373 4.373 0 014.307 3.665 170.238 170.238 0 010 51.813 4.373 4.373 0 01-4.307 3.665h-40.527a4.318 4.318 0 01-3.41-1.653z"
        fill="#6c63ff"
      />
      <path
        d="M12.582 428.128h773.294a1.19 1.19 0 100-2.382H12.582a1.19 1.19 0 100 2.382z"
        fill="#3f3d56"
      />
      <path
        d="M289.135 183.822h-21.35a3.003 3.003 0 01-3-3v-1.274a3.003 3.003 0 013-3h21.35a3.003 3.003 0 013 3v1.274a3.003 3.003 0 01-3 3zM289.135 196.37h-21.35a3.003 3.003 0 01-3-3v-1.275a3.003 3.003 0 013-3h21.35a3.003 3.003 0 013 3v1.274a3.003 3.003 0 01-3 3zM274.995 71.914h-20.923a3.003 3.003 0 01-3-3v-1.172a3.003 3.003 0 013-3h20.923a3.003 3.003 0 013 3v1.172a3.003 3.003 0 01-3 3zM408.675 160.043H387.75a3.003 3.003 0 01-3-3v-1.172a3.003 3.003 0 013-3h20.924a3.003 3.003 0 013 3v1.172a3.003 3.003 0 01-3 3zM408.675 174.857H387.75a3.003 3.003 0 01-3-3v-1.172a3.003 3.003 0 013-3h20.924a3.003 3.003 0 013 3v1.172a3.003 3.003 0 01-3 3zM408.675 189.67H387.75a3.003 3.003 0 01-3-3v-1.172a3.003 3.003 0 013-3h20.924a3.003 3.003 0 013 3v1.172a3.003 3.003 0 01-3 3zM274.995 84.259h-20.923a3.003 3.003 0 01-3-3v-1.173a3.003 3.003 0 013-3h20.923a3.003 3.003 0 013 3v1.173a3.003 3.003 0 01-3 3zM347.172 21.895H326.25a3.003 3.003 0 01-3-3v-1.172a3.003 3.003 0 013-3h20.923a3.003 3.003 0 013 3v1.172a3.003 3.003 0 01-3 3zM442.646 74.929h-20.923a3.003 3.003 0 01-3-3v-1.173a3.003 3.003 0 013-3h20.923a3.003 3.003 0 013 3v1.173a3.003 3.003 0 01-3 3z"
        fill="#fff"
      />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.number.isRequired,
}

const ProjectTeam = styled(Icon)([], space, color, display)

ProjectTeam.displayName = 'ProjectTeam'

ProjectTeam.defaultProps = {
  size: 24,
}

export default ProjectTeam
